import { useAutoneTranslation } from '@autone/translations';
import { TailwindInputWithIcon, useDebounceEffect } from '@autone/ui';
import { Search } from 'lucide-react';
import { useState } from 'react';

import { type APP_NAME } from '../../consts';
type Props = {
  value: string;
  onChange: (value: string) => void;
};

const AssortmentSearchInput = ({ value, onChange }: Props) => {
  const { common } = useAutoneTranslation<typeof APP_NAME>();
  const [localValue, setLocalValue] = useState(value);

  useDebounceEffect(
    () => {
      onChange(localValue);
    },
    [localValue, onChange],
    300,
  );

  return (
    <TailwindInputWithIcon
      className="h-12"
      color={'secondary'}
      icon={<Search className="text-grey-40 w-5 h-5" />}
      placeholder={common('search-placeholder')}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
    />
  );
};

export default AssortmentSearchInput;
